import React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'

const StyledTr = styled('tr')`
  border-bottom: 1px solid ${({ theme, noBorder }) => noBorder ? theme.backgroundColor.white : theme.gray.light};
  font-weight: ${({isBoldRow}) => isBoldRow && 'bold'};

  &.type td:first-child {
    position: relative;

    ::before {
      content: '';
      width: 4px;
      height: 100%;
      display: block;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  @media only screen and (min-width: 960px) {
    &.type td:first-child::before {
      height: 16px;
      top: 50%;
      margin-top: -8px;
    }
  }
`

const LedgerRow = ({ onClick, children, ...rest }) => (
  <StyledTr onClick={onClick} {...rest}>
    {children}
  </StyledTr>
)

LedgerRow.propTypes = {
  itemType: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.any.isRequired,
  onClick: PropTypes.func,
}

export default LedgerRow
